<template>
  <div>
    <h1 class="font-weight-bolder">
      {{ $t('allMyQuotes') }}
    </h1>

    <div class="mb-1">
      <b-form-group
        :label="$t('quoteFolio')"
        label-for="customer-quote-folio-search"
      >
        <b-input-group>
          <b-form-input
            id="customer-quote-folio-search"
            v-model.trim="quoteFolio"
            placeholder="F1234"
            @keyup.enter="applyFilters"
          />
          <b-input-group-append>
            <b-button
              variant="outline-primary"
              @click="applyFilters"
            >
              {{ $t('search') || 'Buscar' }}
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>
    </div>

    <b-overlay :show="loading">
      <quotes-table
        :quotes="quotes"
        :show-project-column="true"
        @sort-changed="handleSort"
        @quote-deleted="fetchData"
        @quote-nickname-updated="fetchData"
      />
    </b-overlay>

    <b-pagination
      :value="quotesPagination.page"
      :total-rows="quotesPagination.total_objects"
      :per-page="quotesPagination.per_page"
      @change="nextPage($event)"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import QuotesTable from '@/components/pricing/QuotesTable.vue'

export default {
  components: { QuotesTable },

  data() {
    return {
      loading: false,
      quoteFolio: '',
      sortField: null,
      sortDirection: null,
    }
  },

  computed: {
    ...mapGetters('quotes', ['quotes', 'quotesPagination']),
    ...mapGetters('auth', ['currentUser']),
  },

  created() {
    this.fetchData()
  },

  destroyed() {
    this.clearQuotes()
  },

  methods: {
    ...mapMutations('quotes', {
      clearQuotes: 'CLEAR_QUOTES',
      changePagination: 'CHANGE_PAGINATION',
    }),
    ...mapActions('quotes', ['fetchQuotes']),

    normalizedQuoteFolio() {
      return this.quoteFolio.toString().trim()
    },

    applyFilters() {
      this.changePagination({ field: 'page', value: 1 })
      this.fetchData()
    },

    fetchData() {
      this.loading = true

      const { customerId } = this.$route.params

      const params = {
        by_customer: customerId,
        meta: { pagination: this.quotesPagination },
        ...(this.normalizedQuoteFolio() ? { by_folio: this.normalizedQuoteFolio() } : {}),
      }

      if (this.sortField && this.sortDirection) {
        params.sort = `${this.sortField}:${this.sortDirection}`
      }

      this.fetchQuotes(params).finally(() => {
        this.loading = false
      })
    },

    nextPage(page) {
      this.changePagination({ field: 'page', value: page })
      this.fetchData()
    },

    handleSort({ field, direction }) {
      this.sortField = field
      this.sortDirection = direction
      this.fetchData()
    },
  },
}
</script>
